<template>
  <div class="alert-overlay">
    <div v-if="loading" class="spinner-box">
      <i class="fas fa-spinner fa-spin fa-3x"></i>
    </div>
    <div v-else class="alert-box">
      <h2>{{ title }}</h2>
      <p>{{ message }}</p>
      <button @click="$emit('close')">Entendi</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Atenção'
    },
    message: {
      type: String,
      required: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.alert-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(50, 50, 50, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* ALERT NORMAL */
.alert-box {
  background-color: white;
  padding: 30px;
  max-width: 90%;
  width: 400px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 2px 20px rgba(0,0,0,0.3);  
  color: #32355d;
}

.alert-box h2 {
  margin-bottom: 10px;
  color: #f78da7;
}

.alert-box p {
  margin-bottom: 20px;
}

.alert-box button {
  background-color: #f78da7;
  color: white;
  border: none;
  padding: 10px 20px;
  font-weight: bold;
  border-radius: 6px;
  cursor: pointer;
}

.alert-box button:hover {
  background-color: #e06c8b;
}

/* SPINNER */
.spinner-box {
  color: white;
}
</style>
